import { Text, View } from '@react-pdf/renderer'
import { FC } from 'react'
import { isAnswered } from 'src/exShared/util/report/isAnswered'
import { hasNoProductMasterData } from 'src/exShared/util/reportResult/hasNoProductMasterData'
import { TableSectionCell } from 'src/features/reports/result/components/reportResult/TableSection/parseTableSection'
import ReactPDFImage from '../ReactPDFImage'
import { buildCellContent } from './buildCellContent'
import { tableStyles } from './styles'

type Props = {
  cell: TableSectionCell
}

/**
 * PDF の表セクションの本体セル1つ。
 * 画面側の TableSectionBodyCell と同じ状態（非活性・該当なし・未回答・逸脱・通常）を描画する。
 */
export const ReportSummaryTableSectionCell: FC<Props> = ({ cell }) => {
  const question = cell.questionNode.question

  // 条件を満たさない分岐セルは回答対象外。「ー」で示す
  if (!cell.active) {
    return (
      <Text style={[tableStyles.bodyCell, tableStyles.inactiveCell]}>ー</Text>
    )
  }

  // responseType は型上オプショナルだが、未サポート/未設定の質問は描画できないので空セル
  if (!question?.responseType) {
    return <Text style={tableStyles.bodyCell} />
  }

  // 記録時に「該当なし」が選択されたセル。灰色セル + 横線で表す
  if (question.responseAnswer?.noAnswer) {
    return (
      <View style={[tableStyles.bodyCell, tableStyles.noAnswerCell]}>
        <View style={tableStyles.noAnswerLine} />
      </View>
    )
  }

  if (hasNoProductMasterData(question)) {
    return (
      <Text style={[tableStyles.bodyCell, tableStyles.unansweredCell]}>
        この製品では、管理者の設定により回答は不要です
      </Text>
    )
  }

  if (!isAnswered(question, true)) {
    return (
      <Text style={[tableStyles.bodyCell, tableStyles.unansweredCell]}>
        未回答
      </Text>
    )
  }

  const content = buildCellContent(question, question.responseType)
  if (content.kind === 'signature') {
    return (
      <View style={tableStyles.bodyCell}>
        <ReactPDFImage uri={content.url} style={tableStyles.signatureImage} />
      </View>
    )
  }
  if (content.kind === 'empty') {
    return <Text style={tableStyles.bodyCell} />
  }

  return (
    <Text
      style={[
        tableStyles.bodyCell,
        ...(content.isInvalid ? [tableStyles.invalidCell] : []),
        ...(content.fontColor ? [{ color: content.fontColor }] : []),
      ]}
    >
      {content.text}
    </Text>
  )
}
